export default class ControleDebitosGatewayError extends Error {
  constructor() {
    super();
    this.message = "Não foi possível pesquisar os controle de débitos";
  }
}
